/** Grid row / cell body text size, shared by banners, alerts and row cards. */
export const APP_BODY_FONT_SIZE_PX = 9.75;
